import {useMutation, UseMutationResult} from '@tanstack/react-query';
import {useLocale} from 'state/locale';
import Api from 'types/api';
import {request} from 'utils/request';

export type ProfileErrorResponse = Api.Response.Failure<'username'>;

export type ProfileRequest = {
    username: string;
};

export type ProfileSuccessResponse = Api.Response.Success<never>;

export const usePatchProfile = (): UseMutationResult<
    ProfileSuccessResponse,
    ProfileErrorResponse,
    ProfileRequest
> => {
    const locale = useLocale();

    return useMutation((formData) =>
        request({
            formData,
            locale,
            method: 'PATCH',
            uri: '/api/profile/',
        }),
    );
};
